import Axios from 'axios';
import store from 'store/store';
import { CreateCloseLead } from 'views/types/lead.types';
import { baseUrl, formNames, redirect_URL, requestHeader } from '../../config';
import { checkAppraisalRouter, checkIsLowBudget, checkIsUserPage, checkShowPromoCode, checkUserInterestIn, closeWindows, getCaptchaToken, getLocalStorageValue, handlePageLoader, handleToast, localStorageKeyValue, loginSignUpSuccess, removeLocalStorageValue, setLocalStorageValue } from '../../utils/handler';
import { CatchReturnError } from './actionHandler';
import { APPRAISAL_LIMIT_COUNT, EMAIL_VERIFICATION, GOOGLE_PROFILE, PASSWORD_SENT_ALERT, ROBOT_PAGE, SHOW_BAD_LEAD, SHOW_LOGIN_WINDOW, SHOW_PROMO_CODE, SHOW_UPGRADE_WINDOW, SIGN_UP_WITH_DOMAIN } from './types';

export const validateBot = async (actionName: string, showErrorPage = false) => {
  let token = await getCaptchaToken(actionName)
  return await Axios.get(baseUrl + '/validateBot/' + token)
    .then((response) => {
      let isHuman = response['data'];
      if (showErrorPage && !isHuman) {
        store.dispatch({ type: ROBOT_PAGE, payload: true })
      }
      if (!isHuman) {
        handleToast({ message: "You sounds like robot!" })
      }
      return isHuman
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getMyCountryObj = async () => {
  return await Axios.get('https://ipapi.co/json/')
    .then((response) => {
      let data = response.data;
      return data;
    })
    .catch((error) => {
      return {
        country_name: 'United States',
        country_code: 'US',
      };
    });
};

export const uploadFile = (file: File) => {
  let formData = new FormData();
  formData.append('file', file);
  return Axios.post(baseUrl + '/files', formData)
    .then((res) => {
      let { files } = res['data'];
      if (files) {
        return files[0].filename;
      }
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const createCloseContactUsLead = (payload: CreateCloseLead) => {
  let referrerURL = document.referrer;
  if (referrerURL && referrerURL.includes(redirect_URL)) {
    referrerURL = '';
  }
  if (referrerURL) payload.referralURL = referrerURL;
  payload.registrarUID = getRegistrarDetailFromStore(payload);

  // const {registrarDetails} = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //   // payload.registrarUID = registrarDetails.UID;
  //   payload.leadSource = registrarDetails.name || registrarDetails.website
  // }

  handlePageLoader(true);
  return Axios.post(baseUrl + '/createCloseLead', payload)
    .then((res) => {
      handlePageLoader(false);
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const sendQuestion = (payload: { email: string; comments: string }) => {
  return Axios.post(baseUrl + '/sendQuestion', payload)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const verifyUser = (payload: any) => {
  return Axios.get(baseUrl + '/verifyUser/' + payload.userUID)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const resetPassword = (payload: {
  email: string;
  OTP: number;
  password: string;
  confirmPassword: string;
}) => {
  return Axios.patch(baseUrl + '/resetPassword', payload)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const forgotPassword = (payload: {email: string}) => {
  return Axios.patch(baseUrl + '/forgotPassword', payload)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const sendVerificationCode = (email: string) => {
  return Axios.post(baseUrl + '/sendVerificationCode', { email })
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const verifyEmailByCode = (payload: { verificationCode: number; email: string }) => {
  return Axios.patch(baseUrl + '/verifyEmailByCode', payload)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const oneTabLogin = (payload: any) => {
  // const {registrarDetails} = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //     payload.registrarUID = registrarDetails.UID;
  // }
  payload.registrarUID = getRegistrarDetailFromStore(payload);
  closeWindows();
  return Axios.post(baseUrl + '/oneTabLogin', payload)
    .then((res) => {
      let response = res['data'];
      if (res.status === 200) {
        loginSignUpSuccess(response);
      } else {
        store.dispatch({ type: GOOGLE_PROFILE, payload: payload });
      }
      return response;
    })
    .catch((err: any) => {
      CatchReturnError(err);
    });
};
export const login = (payload: any) => {
  payload.roleType = checkIsUserPage();
  setLocalStorageValue(localStorageKeyValue.userEmail, payload.email);
  return Axios.post(baseUrl + '/login', payload)
    .then((res) => {
      if (res.status === 207) {
        store.dispatch({ type: EMAIL_VERIFICATION, payload: true });
      } else {
        return res['data'];
      }
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const socialLogin = (payload: any) => {
  let domainName = getLocalStorageValue(localStorageKeyValue.domainName);
  if (domainName) {
    payload.domainName = domainName;
  }
  // const {registrarDetails} = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //     payload.registrarUID = registrarDetails.UID;
  // }
  payload.registrarUID = getRegistrarDetailFromStore(payload);
  payload.appraisalUser = checkAppraisalRouter() ? true : false;

  return Axios.post(baseUrl + '/socialLogin', payload)
    .then((res) => {
      // receive 201 if new user
      if (res.status === 201) {
        store.dispatch({ type: PASSWORD_SENT_ALERT, payload: true });
        if (checkShowPromoCode(payload)) store.dispatch({ type: SHOW_PROMO_CODE, payload: true });
      }
      removeLocalStorageValue(localStorageKeyValue.domainName)
      // removeLocalStorageItems()
      return res['data'];
    })
    .catch((err: any) => {
      CatchReturnError(err);
    });
};

export const linkedInLogin = (payload: any) => {
  let domainName = getLocalStorageValue(localStorageKeyValue.domainName);
  if (domainName) {
    payload.domainName = domainName;
  }
  // const {registrarDetails} = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //     payload.registrarUID = registrarDetails.UID;
  // }
  payload.registrarUID = getRegistrarDetailFromStore(payload);
  payload.appraisalUser = checkAppraisalRouter() ? true : false;

  return Axios.post(baseUrl + '/linkedInLogin', payload)
    .then((res) => {
      // receive 201 if new user
      if (res.status === 201) {
        store.dispatch({ type: PASSWORD_SENT_ALERT, payload: true });
        if (checkShowPromoCode(payload)) store.dispatch({ type: SHOW_PROMO_CODE, payload: true });
      }
      removeLocalStorageValue(localStorageKeyValue.domainName)
      // removeLocalStorageItems()
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const signup = (payload: any) => {
  let domainName = getLocalStorageValue(localStorageKeyValue.domainName);
  let offerAmount = getLocalStorageValue(localStorageKeyValue.offerAmount);
  if (domainName) {
    payload.domainName = domainName;
    payload.offerAmount = offerAmount;
  }
  if (!payload.userInterested) {
    payload.userInterested = checkUserInterestIn();
  }
  // const {registrarDetails} = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //     payload.registrarUID = registrarDetails.UID
  // }
  payload.registrarUID = getRegistrarDetailFromStore(payload);

  payload.appraisalUser = checkAppraisalRouter() ? true : false;
  setLocalStorageValue(localStorageKeyValue.userEmail, payload.email);

  if (document.referrer && !document.referrer.includes(redirect_URL)) {
    payload.referralURL = document.referrer;
  }
  payload.formName = checkAppraisalRouter() ? formNames.appraisalBuy : formNames.defaultForm;

  return Axios.post(baseUrl + '/signup', payload)
    .then((res) => {
      if (res.status === 207) {
        store.dispatch({ type: EMAIL_VERIFICATION, payload: true });
      } else if (res.status === 203) {
        handleToast({ message: res.data });
        store.dispatch({ type: SHOW_UPGRADE_WINDOW, payload: false });
        store.dispatch({ type: SIGN_UP_WITH_DOMAIN, payload: false });
        store.dispatch({ type: SHOW_LOGIN_WINDOW, payload: true });
      } else {
        if (!payload.password) {
          store.dispatch({ type: PASSWORD_SENT_ALERT, payload: true });
        }
        if (checkShowPromoCode(payload)) store.dispatch({ type: SHOW_PROMO_CODE, payload: true });
        // removeLocalStorageItems()
        removeLocalStorageValue(localStorageKeyValue.domainName)
        return res['data'];
      }
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const getRegistrarDetailFromStore = (payload: { domainName: string; offerAmount?: string; registrarUID?: string }) => {
  const { registrarDetails } = store.getState().userReducer;
  if (registrarDetails && registrarDetails.UID) {
    payload.registrarUID = registrarDetails.UID;
    return payload.registrarUID;
  }
  return undefined;
};

export const signUpWithDomain = async (payload: any, checkLowBudget = true) => {
  let domainName = getLocalStorageValue(localStorageKeyValue.domainName);
  // const {registrarDetails} = store.getState().userReducer;
  if (!payload.domainName && domainName) {
    payload.domainName = domainName;
  }
  // const {registrarDetails} = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //     payload.registrarUID = registrarDetails.UID
  // }
  payload.registrarUID = getRegistrarDetailFromStore(payload);
  // if (registrarDetails) {
  //   payload.leadSource = registrarDetails.name || registrarDetails.website
  // }
  if (payload.registrarUID && checkLowBudget && await checkIsLowBudget(payload)) {
    return true;
  }
  if (!payload.userInterested) {
    payload.userInterested = checkUserInterestIn();
  }
  payload.appraisalUser = checkAppraisalRouter() ? true : false;

  // if (payload.registrarUID) {
  //     // const { registrarDetails } = store.getState().userReducer;
  //     // payload.leadSource = registrarDetails.name
  // } else {
  //     // payload.leadSource = document.referrer
  // }

  if (document.referrer && !document.referrer.includes(redirect_URL)) {
    payload.referralURL = document.referrer;
  }

  setLocalStorageValue(localStorageKeyValue.userEmail, payload.email);
  handlePageLoader(true);
  closeWindows();
  payload.formName = checkAppraisalRouter() ? formNames.appraisalBuy : formNames.defaultForm;
  return Axios.post(baseUrl + '/signUpWithDomain', payload)
    .then((res) => {
      handlePageLoader(false);
      if (res.status === 207) {
        store.dispatch({ type: EMAIL_VERIFICATION, payload: true });
      } else if (res.status === 203) {
        handleToast({ message: res.data });
        store.dispatch({ type: SIGN_UP_WITH_DOMAIN, payload: false });
        store.dispatch({ type: SHOW_LOGIN_WINDOW, payload: true });
      } else {
        if (!payload.password) store.dispatch({ type: PASSWORD_SENT_ALERT, payload: true });
        if (checkShowPromoCode(payload)) store.dispatch({ type: SHOW_PROMO_CODE, payload: true });
        let code = res['data'];
        closeWindows();
        // removeLocalStorageItems()
        removeLocalStorageValue(localStorageKeyValue.domainName)
        loginSignUpSuccess(code);
        return code;
      }
      return true;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

interface CreateLeadWithoutSignupType {
  name: string,
  email: string,
  phone: string,
  domainName: string,
  offerAmount: string,
  comments?: string,
  registrarUID?: string,
  leadSource?: string,
  referralURL?: string,
  currentURL?: string,
}

export const createLeadWithoutSignup = async (formData: CreateLeadWithoutSignupType) => {
  const payload: any = {}
  // payload.registrarUID = getRegistrarDetailFromStore(payload);

  const referralURL = getLocalStorageValue("referralURL")
  const registrarUID = getLocalStorageValue(localStorageKeyValue.registrarUID)

  console.log({
    email: formData.email,
    referralURL,
    registrarUID: registrarUID
  })

  setLocalStorageValue(localStorageKeyValue.userEmail, formData.email);
  handlePageLoader(true);

  return Axios.post(baseUrl + '/createLeadWithoutSignup', {
    ...formData,
    registrarUID: registrarUID || "",
    referralURL: referralURL || "",
    currentURL: window.location.href
  })
    .then((res) => {
      handlePageLoader(false);
      if (res.data === "BAD LEAD" || res.status === 203) {
        store.dispatch({ type: SHOW_BAD_LEAD, payload: true });
      } else {
        // if (!payload.registrarUID && res.status === 200) store.dispatch({ type: SHOW_PROMO_CODE, payload: true });
        closeWindows();
        removeLocalStorageValue(localStorageKeyValue.domainName)
      }
      return {
        status: res?.status,
        data: res?.data
      };
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

interface TestTempAPIType {
  budget: string,
  comment?: string,
}

export const testTempApi = async (formData: TestTempAPIType) => {
  return Axios.post(baseUrl + '/temp-test', formData)
    .then((res) => {
      handlePageLoader(false);
      return res.data
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getPaymentLink = async (leadUID: string) => {
  return Axios.get(baseUrl + '/makePaymentWithoutSignup/' + leadUID)
    .then((res) => { return res?.data })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getPaymentStatus = async (sessionId: string) => {
  return Axios.get(baseUrl + '/getPaymentStatus/' + sessionId)
    .then((res) => {
      return {
        status: res?.status,
        data: res?.data
      };
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getCalendly = async (leadUID: string) => {
  return Axios.get(baseUrl + '/getCalendly/' + leadUID)
    .then((res) => { return res?.data })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getMyAppraisalCount = () => {
  return Axios.get(baseUrl + '/getMyAppraisalCount', requestHeader)
    .then((res) => {
      store.dispatch({ type: APPRAISAL_LIMIT_COUNT, payload: res['data'] });
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
// export const getTodayAppraisalLimit = () => {
//     return Axios.get(baseUrl + '/todayAppraisalLimit', requestHeader).then(res => {
//         store.dispatch({type: TODAY_APPRAISAL_LIMIT_COUNT, payload: res["data"].count});
//         return res["data"]
//     }).catch(err => {
//         CatchReturnError(err)
//     })
// }

export const unsubscribeEmail = (payload: { closeUID?: string; message?: string; email: string; type: string; token?: string }) => {
  return Axios.patch(baseUrl + '/unsubscribeEmail', payload, requestHeader)
    .then((res) => {
      return res['data'];
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const sendLowBudgetMail = (payload: { lowBudgetNote?: string; domainName: string; offerAmount: string; email: string }) => {
  if (payload && payload.email) {
    setLocalStorageValue(localStorageKeyValue.userEmail, payload.email)
    return Axios.post(baseUrl + '/sendLowBudgetMail', payload, requestHeader)
      .then((res) => {
        if (res.status === 203) {
          handleToast({ message: res.data });
          store.dispatch({ type: SIGN_UP_WITH_DOMAIN, payload: false });
          store.dispatch({ type: SHOW_LOGIN_WINDOW, payload: true });
        } else {
          return res['data'];
        }
      })
      .catch((err) => {
        CatchReturnError(err);
      });
  }
};

export interface AffiliateSignupPayload {
  name: string;
  address: string;
  website: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
  termsAccepted: boolean;
}

const affiliateSignupError = (message: unknown) =>
  typeof message === 'string' && message ? message : 'Something went wrong. Please try again.';

export const affiliateSignup = async (formData: AffiliateSignupPayload): Promise<{ affiliateId?: string; error?: string }> => {
  try {
    const captchaToken = await getCaptchaToken('affiliateSignup');
    const res = await Axios.post(baseUrl + '/affiliateSignup', { ...formData, captchaToken });
    if (res.data?.affiliateId) return { affiliateId: res.data.affiliateId };
    return { error: affiliateSignupError(res.data) };
  } catch (err: any) {
    return { error: affiliateSignupError(err?.response?.data) };
  }
};
